// Generated with util/create-component.js
import React, { useEffect, useState } from 'react'

import { LoadingProps } from './Loading.types'
import Icon from '../Icon/Icon'
const Loading: React.FC<LoadingProps> = ({
    overlay = false,
    loading,
    translucent = false,
    children,
    message,
    height,
    width,
}) => {
    const [internalLoading, setInternalLoading] = useState(loading)

    useEffect(() => {
        if (!loading) {
            setTimeout(() => {
                setInternalLoading(false)
            }, 100)
        }
    }, [loading])

    const getClassNames = () => {
        const c = ['r-loadable-container']

        if (translucent) {
            c.push('r-load-translucent')
        }
        if (overlay) {
            c.push('r-load-overlay')
        }

        return c.join(' ')
    }

    if (!loading) {
        return children || null
    }

    const style = {
        height,
        width,
    }

    if (loading && overlay) {
        return (
            <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                {children}
                <div data-testid='Loading' style={style} className={getClassNames()}>
                    <div className='r-loadable-visual'>
                        <Icon type={'spinner'} spin />
                        <div className='r-loading-message'>{message}</div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div data-testid='Loading' style={style} className={getClassNames()}>
            <div className='r-loadable-visual'>
                <Icon type={'spinner'} spin />
                <div className='r-loading-message'>{message}</div>
            </div>
        </div>
    )
}

export default Loading
